import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { UserCard } from '../../UserCard/UserCard';
import { PinButton, SidebarBase, SidebarUtilityNav } from '../common';
import { ExternalSidebarClassNames } from './ExternalSidebar.styles';
import { ExternalSidebarLogo, ExternalSidebarTagline } from './ExternalSidebarLogo';
import { ExternalSidebarNavigation } from './ExternalSidebarNavigation';

export const ExternalSidebar: FC = () => {
  return (
    <SidebarBase>
      {({ onPinClick, pinButtonRef }) => (
        <div className='flex min-h-0 flex-1 flex-col gap-4 group-data-[expanded=false]/sidebar:gap-2'>
          <div className='flex shrink-0 flex-col gap-4 group-data-[expanded=false]/sidebar:gap-0'>
            <div className='flex shrink-0 justify-between items-center group-data-[expanded=false]/sidebar:flex-col'>
              <ExternalSidebarLogo />
              <PinButton ref={pinButtonRef} onClick={onPinClick} classNames={{}} />
            </div>
            <ExternalSidebarTagline
              className={twMerge(
                'hidden shrink-0',
                'transition-discrete starting:opacity-0 motion-safe:delay-200 motion-safe:duration-500',
                'group-data-[expanded=true]/sidebar:block'
              )}
            />
          </div>
          <div className='min-h-0 flex-1 overflow-y-auto overscroll-contain'>
            <ExternalSidebarNavigation />
          </div>
          <SidebarUtilityNav classNames={ExternalSidebarClassNames} />
          <UserCard />
        </div>
      )}
    </SidebarBase>
  );
};
